import { parseNoteRef } from "@plannello/shared";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { ProductNotesPage } from "@/components/notes/NotesPages";

/** /p/KEY/notes/12/slug: a note of a product. `?edit=1` opens the editor (right after creating). */
export const Route = createFileRoute("/_app/p/$productKey/notes/$ref/{-$slug}")({
  validateSearch: (s: Record<string, unknown>): { edit?: "1" } => (s.edit === "1" || s.edit === 1 ? { edit: "1" } : {}),
  beforeLoad: ({ params }) => {
    if (!parseNoteRef(params.ref)) throw notFound();
  },
  component: View,
});

function View() {
  const { productKey, ref, slug } = Route.useParams();
  const { edit } = Route.useSearch();
  return (
    <ProductNotesPage productKey={productKey} refNum={parseNoteRef(ref) ?? undefined} slug={slug} edit={edit === "1"} />
  );
}
